import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import './i18n/i18n';
import {StylesProvider} from '@material-ui/core/styles';
import {jssPreset} from "@material-ui/core";
import {create} from 'jss';

const jss = create({
    ...jssPreset(),
    insertionPoint: document.getElementById('jss-insertion-point'),
});

ReactDOM.render(<StylesProvider jss={jss}>
    <App/>
</StylesProvider>, document.getElementById('root'));

serviceWorker.unregister();
